<ion-card class="app-background">
  <ion-card-header class="ion-no-padding">
    <ion-item-divider>
      <ion-label class="text-dark-500 text-bold">{{ title() }}</ion-label>
    </ion-item-divider>
  </ion-card-header>

  @if (isEmpty()) {
    <div
      class="ion-padding ion-no-margin ion-justify-content-center ion-align-items-center"
    >
      <div class="ion-padding panel-border">
        {{ 'dashboard_messages_empty' | translate }}
      </div>
    </div>
  } @else {
    @for (
      message of messages()
        | paginate: { itemsPerPage: 6, currentPage: currentPage() };
      track $index
    ) {
      <ion-item class="activated ion-item-resize" lines="full">
        @if (message?.type && message.type === 'configuration') {
          <ion-grid class="ion-no-padding">
            <ion-row class="vertical-center ion-no-padding">
              <ion-col size="1" class="ion-no-padding mr--1">
                @if (
                  message?.message &&
                  message.message === 'configuration_accepted'
                ) {
                  <ion-icon
                    name="checkmark-outline"
                    class="ion-no-padding-end"
                  ></ion-icon>
                } @else if (
                  message?.message &&
                  message.message === 'configuration_refused'
                ) {
                  <ion-icon
                    name="warning"
                    class="ion-no-padding-end"
                  ></ion-icon>
                } @else if (
                  message?.message &&
                  message.message === 'configuration_installed'
                ) {
                  <ion-icon
                    name="checkmark-circle"
                    class="ion-no-padding-end"
                  ></ion-icon>
                }
              </ion-col>
              <ion-col size="7">
                @if (
                  message?.message &&
                  message.message !== 'configuration_accepted'
                ) {
                  <ion-label>
                    {{ message.name }} {{ message.message | translate }}
                    {{ 'messages_yourConfiguration' | translate }}</ion-label
                  >
                } @else if (
                  message?.message &&
                  message.message === 'configuration_installed'
                ) {
                  <ion-label>
                    Configuration of {{ message.name }} has been
                    {{ message.message | translate }}</ion-label
                  >
                }
              </ion-col>
              <ion-col size="4">
                <ion-label class="ion-text-end mr--1">{{
                  message.date
                }}</ion-label>
              </ion-col>
            </ion-row>
          </ion-grid>
        } @else if (message?.type && message.type === 'controller') {
          <ion-grid class="ion-no-padding">
            <ion-row class="vertical-center ion-no-padding">
              <ion-col size="1" class="ion-no-padding mr--1">
                <ion-icon name="wifi" class="ion-no-padding-end"></ion-icon>
              </ion-col>
              <ion-col size="7">
                @if (
                  message?.message &&
                  message.message !== 'configuration_installed'
                ) {
                  <ion-label
                    >Controller {{ message.name }} has been offline for more
                    than {{ message.date | timeAgo }}</ion-label
                  >
                }
              </ion-col>
              <ion-col size="4">
                <ion-label class="ion-text-end mr--1">{{
                  message.date
                }}</ion-label>
              </ion-col>
            </ion-row>
          </ion-grid>
        }
      </ion-item>
    }

    <pagination-controls
      class="ion-no-padding ion-no-margin"
      [maxSize]="5"
      [directionLinks]="true"
      [autoHide]="true"
      [responsive]="true"
      previousLabel=""
      nextLabel=""
      (pageChange)="pageChanged($event)"
    ></pagination-controls>
  }
</ion-card>
